import { render, staticRenderFns } from "./CorpsSpends.vue?vue&type=template&id=dd40fd24"
import script from "./CorpsSpends.vue?vue&type=script&lang=ts"
export * from "./CorpsSpends.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports